import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm text-gray-500 my-4"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-2 text-sm text-red-600"
}

import { computed, onMounted, ref, watch } from "vue"
import { VueTelInput } from "vue-tel-input"
import { Phone, PhoneNumber } from "@/shared/models/phone"
import { CountryCode } from "libphonenumber-js"

interface Props {
    modelValue?: Phone
    label?: string
    description?: string
    placeholder?: string
    defaultRegion?: string
    inline?: boolean
    invalid?: boolean
    disabled?: boolean
    required?: boolean
    errorMessage?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GgmsPhoneTelInput',
  props: {
    modelValue: {},
    label: {},
    description: {},
    placeholder: { default: "Phone Number" },
    defaultRegion: { default: "US" },
    inline: { type: Boolean },
    invalid: { type: Boolean, default: false },
    disabled: { type: Boolean },
    required: { type: Boolean, default: false },
    errorMessage: {}
  },
  emits: ["update:modelValue", "onKeydown", "update:invalid", "onchange"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "1a40e139": (telInputWidth.value)
}))

const props = __props

const emit = __emit

const phoneNumber = computed({
    get() {
        return props.modelValue as Phone
    },
    set(value: Phone) {
        emit("update:modelValue", value)
        emit("onchange", value)
    },
})
const localInvalid = ref(props.invalid)
const localErrorMessage = ref(props.errorMessage)

const phone = ref<PhoneNumber>(setDefaultModelValue())
const telInput = ref()
const telInputWidth = ref("0px")
const placeholder = ref(props.placeholder)

const getWrapperStyleInline = computed(() => (props.inline ? "flex items-center" : ""))
const getLabelStyleInline = computed(() => [props.inline ? "w-2/5" : "", "h-6"])
const getRequiredStyleInline = computed(() => (props.inline ? "gap-2" : ""))
const inputStyle = computed(() => [
    props.disabled ? "opacity-50 cursor-not-allowed" : "",
    localInvalid.value
        ? "border-2 border-red-300  placeholder-red-300 ring-1 ring-red-300 focus:border-2 focus:border-red-300"
        : "",
])
const starStyle = computed(() => [localInvalid.value ? "text-red-600" : "text-gray-700", "pl-1"])

// This function is only called when the input value is changed and not when the modelValue is modified in the parent component
function onInput() {
    disableValidationError()
    const number = telInput.value?.phone || ""
    const phoneObject = telInput.value?.phoneObject

    const newPhone = {
        number,
        country: phoneObject?.countryCode as CountryCode,
    }

    // if there is more than 1 digit in the phoneObject number, we set the formatted number
    if (phoneObject?.number) {
        newPhone.number = phoneObject.formatted
    }
    phoneNumber.value = newPhone

    emit("onKeydown")
}

function disableValidationError() {
    localErrorMessage.value = ""
    localInvalid.value = false
}

function setDefaultModelValue() {
    return {
        countryCode: props.modelValue?.country || props.defaultRegion,
        number: props.modelValue?.number || "",
        country: { name: "", iso2: props.modelValue?.country || props.defaultRegion, dialCode: "" },
        countryCallingCode: "",
        formatted: props.modelValue?.number || "",
        nationalNumber: "",
        valid: false,
    }
}

onMounted(() => {
    telInputWidth.value = `${telInput.value.$el.offsetWidth}px`
})

watch(
    () => props.errorMessage,
    (newVal) => {
        localErrorMessage.value = newVal
        localInvalid.value = props.invalid
    }
)

watch(
    () => props.invalid,
    () => {
        localInvalid.value = props.invalid
    }
)

watch(
    () => props.defaultRegion,
    () => {
        telInput.value.activeCountryCode = props.defaultRegion
    }
)

watch(
    () => props.modelValue,
    () => {
        phone.value = setDefaultModelValue()
        if (!props.modelValue?.number && props.invalid) {
            localErrorMessage.value = props.errorMessage
            localInvalid.value = props.invalid
        }
    },
    {
        deep: true,
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(getWrapperStyleInline.value)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex", getRequiredStyleInline.value])
    }, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass([getLabelStyleInline.value, 'text-sm font-medium text-gray-700'])
          }, _toDisplayString(_ctx.label), 3))
        : _createCommentVNode("", true),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(starStyle.value)
          }, "*", 2))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(VueTelInput), {
      ref_key: "telInput",
      ref: telInput,
      modelValue: phone.value.formatted,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phone.value.formatted) = $event)),
      mode: "international",
      validCharactersOnly: true,
      defaultCountry: _ctx.defaultRegion,
      inputOptions: { placeholder: placeholder.value },
      disabled: _ctx.disabled,
      class: _normalizeClass(inputStyle.value),
      onInput: onInput
    }, null, 8, ["modelValue", "defaultCountry", "inputOptions", "disabled", "class"]),
    (localErrorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(localErrorMessage.value), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})